import { Component, ChangeDetectionStrategy } from '@angular/core';

import { MdwButton } from '@spaces-ui/meadow/components/button';
import { MdwListItem } from '@spaces-ui/meadow/components/list-item';
import { MdwIcon } from '@spaces-ui/meadow/icons';
import { Home_Fill } from '@spaces-ui/meadow/icons/svgs';

import { Sample } from '../../components';

@Component({
  selector: 'app-badges',
  imports: [Sample, MdwButton, MdwListItem, MdwIcon],
  templateUrl: './badges.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './badges.scss',
})
export class Badges {
  public icons = { Home_Fill };
}
